let deferredPrompt = null;
let installedCache = null;

import { api } from "@/lib/api";

export const deviceId = () => {
  let id = localStorage.getItem("saproject:device-id");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));
    localStorage.setItem("saproject:device-id", id);
  }
  return id;
};

export const recordInstall = (source) => {
  if (localStorage.getItem("saproject:install-recorded")) return;
  localStorage.setItem("saproject:install-recorded", "1");
  api.post("/pwa-installs", { device_id: deviceId(), source }).catch(() => localStorage.removeItem("saproject:install-recorded"));
};

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  installedCache = false;
  localStorage.removeItem("saproject:pwa-installed");
});

window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  installedCache = true;
  localStorage.setItem("saproject:pwa-installed", "1");
});

export const getDeferredPrompt = () => deferredPrompt;
export const clearDeferredPrompt = () => { deferredPrompt = null; };

export const isStandalone = () => {
  if (window.navigator.standalone === true) return true;
  if (window.matchMedia("(display-mode: browser)").matches) return false;
  return ["standalone", "minimal-ui", "fullscreen", "window-controls-overlay"]
    .some((m) => window.matchMedia(`(display-mode: ${m})`).matches);
};

export const checkInstalled = async () => {
  if (installedCache !== null) return installedCache;
  // Local flags are authoritative-positive: they're set when the app is installed
  // via our prompt or first launched standalone, and Android's WebAPK shares
  // profile storage with the browser — so browser tabs know too.
  if (localStorage.getItem("saproject:pwa-installed") === "1" ||
      localStorage.getItem("saproject:install-recorded") === "1") {
    installedCache = true;
    return true;
  }
  try {
    if (navigator.getInstalledRelatedApps) {
      const apps = await navigator.getInstalledRelatedApps();
      installedCache = apps.length > 0;
      return installedCache;
    }
  } catch { /* API unavailable */ }
  return false;
};

export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

export const browserKind = () => {
  const ua = navigator.userAgent;
  if (isIos()) return "ios";
  if (/SamsungBrowser/i.test(ua)) return "samsung";
  if (/Firefox/i.test(ua)) return "firefox";
  if (/Edg\//.test(ua)) return "edge";
  if (/Chrome/i.test(ua)) return "chrome";
  return "other";
};

export const isMobile = () => /Android|Mobile/i.test(navigator.userAgent);

export const installInstructions = () => {
  switch (browserKind()) {
    case "ios":
      return "Tap the Share button in Safari, then choose \"Add to Home Screen\" — it'll appear with your other apps.";
    case "samsung":
      return "Tap the menu button (≡) at the bottom right, then \"Add page to\" → \"Home screen\". If you see a download icon in the address bar, tapping that installs it too.";
    case "firefox":
      return isMobile()
        ? "Tap the menu button, then choose \"Add to Home screen\"."
        : "Desktop Firefox can't install web apps — open this site in Chrome or Edge for one-click install.";
    case "edge":
      return isMobile()
        ? "Tap the menu (…) at the bottom, then \"Add to phone\"."
        : "Click the install icon at the right end of the address bar, or menu (…) → Apps → \"Install this site as an app\".";
    case "chrome":
      return isMobile()
        ? "Tap the menu (⋮), then \"Add to Home screen\" or \"Install app\"."
        : "Click the install icon at the right end of the address bar, or menu (⋮) → \"Cast, save and share\" → \"Install page as app\". If that menu shows \"Open in The Self-Agency Project\" instead, the app is already installed on this computer — click it to open the app.";
    default:
      return "Open your browser's menu and choose \"Install app\" or \"Add to Home Screen\".";
  }
};
